"use client";
import React, { useRef } from "react";
import { motion, useInView } from "motion/react";
import BorderWrapper from "@/components/ui/border-wrapper";
import Image from "next/image";
import { useTranslations } from "next-intl";

const UniqueValue = () => {
  const t = useTranslations("uniqueValue");
  const valueItems = [
    t("items.0"),
    t("items.1"),
    t("items.2"),
    t("items.3"),
  ];
  const sectionRef = useRef<HTMLElement>(null);
  const isInView = useInView(sectionRef, { once: true, margin: "0px 0px -60px 0px" });

  return (
    <section ref={sectionRef} className="section pt-[40px] md:pt-[56px] lg:pt-[70px] pb-[40px] md:pb-[64px] lg:pb-[70px] relative">
      <div className="container relative">
        <div className="absolute left-0 lg:left-[-30%] xl:left-[-26%] -top-[80px] lg:top-[50%] lg:-translate-y-1/2 lg:w-[830px] -z-1 pointer-events-none">
          <Image
            src="/assets/illustrations/why-us.svg"
            alt="Why choose Flyingcode illustration"
            aria-hidden="true"
            width={863}
            height={554}
            className="w-full h-auto object-cover"
          />
        </div>
        <div className="grid items-center sm:grid-cols-[4fr_3fr] gap-[30px]">
          <div className="grid__item">
            <div className="section-header flex justify-center w-full lg:ps-[5rem] relative">
              <motion.h2
                className="text-[28px] md:text-[40px] lg:text-[60px] font-semibold leading-[1.5]"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
              >
                {t("title")}
              </motion.h2>
            </div>
          </div>
          <div className="grid__item">
            <ul className="space-y-[10px]">
              {valueItems.map((text, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 20 }}
                  transition={{ duration: 0.45, ease: "easeOut", delay: index * 0.07 }}
                >
                  <BorderWrapper
                    wrapperClass="rounded-[15px] h-full bg-[linear-gradient(90deg,_#121124_0%,_#353353_100%)]"
                    className="rounded-[15px] px-[15px] lg:px-[30px] min-h-[70px] flex flex-col justify-center py-[10px] h-full bg-gradient-to-b from-[#121124] to-[#0e0821] overflow-hidden"
                  >
                    <div className="flex gap-[15px] items-center">
                      <Image
                        className="min-w-[23px]"
                        src="/assets/illustrations/flyingcode-arrow.svg"
                        alt="Flyingcode arrow"
                        aria-hidden="true"
                        width={23}
                        height={15}
                        style={{ height: "auto" }}
                      />
                      <p className="text-[15px] lg:text-[16px] font-light leading-[1.7] text-foreground/90">
                        {text}
                      </p>
                    </div>
                  </BorderWrapper>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniqueValue;
